import { render, staticRenderFns } from "./ProductEditTaxes.vue?vue&type=template&id=07d6c98b"
import script from "./ProductEditTaxes.vue?vue&type=script&lang=ts"
export * from "./ProductEditTaxes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07d6c98b')) {
      api.createRecord('07d6c98b', component.options)
    } else {
      api.reload('07d6c98b', component.options)
    }
    module.hot.accept("./ProductEditTaxes.vue?vue&type=template&id=07d6c98b", function () {
      api.rerender('07d6c98b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductEditTaxes.vue"
export default component.exports